<template>
    <div>
        <div class="animate-pulse" v-if="inProgress">Daten werden abgerufen...</div>
        <div v-else>
            <div class="flex flex-row">
            <div class="w-4/5">
                <span v-html="details.details"></span>
            </div>
                <div class="w-1/5">
                    <img :src="auction.image_url"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductDetails",
        props: {
            inProgress: Boolean,
            details: Object,
            auction: Object
        },
        data() {
            return {}
        },
        methods: {},
        computed: {}
    }
</script>
